module.exports = __webpack_public_path__ + "static/media/xl_uni.eb9165fa.png";